module.exports = __webpack_public_path__ + "img/text-right.d43865d7.svg";